export type AdapterFieldKind = 'boolean' | 'json' | 'input';

/**
 * Normalizes a data type (master definition names AND typeof-inferred names)
 * into the kind of control the field should render as.
 */
export function fieldKind(dataType: string): AdapterFieldKind {
  const type = (dataType ?? '').toLowerCase();
  if (type === 'boolean' || type === 'bool') return 'boolean';
  if (type === 'jsonb' || type === 'json' || type === 'object') return 'json';
  return 'input';
}

/** HTML input type for fields rendered as a plain input. */
export function inputTypeFor(dataType: string): string {
  const type = (dataType ?? '').toLowerCase();
  if (
    ['number', 'integer', 'int', 'float', 'decimal', 'numeric'].includes(type)
  )
    return 'number';
  if (type === 'email') return 'email';
  if (type === 'password') return 'password';
  return 'text';
}

/**
 * Dynamic inputs always yield strings; convert a form value to the JS type
 * implied by its data type so the submitted payload is correctly typed.
 */
export function coerceSettingValue(dataType: string, value: unknown): unknown {
  switch (fieldKind(dataType)) {
    case 'boolean':
      return value === true || value === 'true';
    case 'json':
      if (typeof value === 'string' && value.trim() !== '') {
        try {
          return JSON.parse(value);
        } catch {
          return value; // jsonValidator already blocks invalid JSON
        }
      }
      return value;
    default:
      if (inputTypeFor(dataType) === 'number') {
        if (value === '' || value === null || value === undefined) return value;
        const num = Number(value);
        return Number.isNaN(num) ? value : num;
      }
      return value;
  }
}
